module.exports = __webpack_public_path__ + "img/ALCALDIA_LOGO.2ae8fd8e.svg";